<template>
  <div>
    <div>
      <router-view v-if="!loading"/>
      <Loader v-else></Loader>
    </div>
  </div>

</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex'

export default {
  computed: mapState([
    'abstract', 'status', 'authors', 'theme_list', 'user', 'submissions'
  ]),
  data() {
    return {
      loading: false,
    };
  },
  watch: {
    '$route.params.id': {
      handler: function (newId, oldId) {
        if (newId && newId !== oldId) {
          this.loadAbstract(newId);
        }
      }
    }
  },
  async created() {
    await this.loadAbstract(this.$route.params.id);
  },
  methods: {
    ...mapActions([
      'GET_USERDATA', 'GET_ONE_ABSTRACT'
    ]),
    ...mapMutations([
      'SET_USER', 'SET_ABSTRACT', 'SET_SETTINGS'
    ]),
    async loadAbstract(id) {
      this.loading = true;
      await this.GET_ONE_ABSTRACT(id).then(async (response) => {
        this.$store.dispatch('IMPLODE_ADDITIONAL_ABSTRACT_DATA', response.data);
        const submissionId = response.data.setting_submission_id;
        let submission = this.findSubmission(submissionId);
        if (!submission) {
          await this.$store.dispatch('GET_ALL_SUBMISSIONS');
          submission = this.$store.state.submissions.find(submission => submission.id == submissionId);
        }
        if (!submission) {
          return;
        }
        const settings = typeof submission.settings === 'string'
            ? JSON.parse(submission.settings)
            : submission.settings;
        const excludeIds = settings.themes && settings.themes.exclude_ids
            ? settings.themes.exclude_ids
            : (submissionId === 3 ? [13] : []);
        this.$store.dispatch('GET_THEME_LIST', {
          themelist_id: submission.themelist_id,
          excludeIds: excludeIds
        });
        this.SET_SETTINGS({settings: submission.settings});
      });
      await this.$store.dispatch('GET_AUTHORS', id);
      await this.$store.dispatch('GET_ALL_GENDER');
      await this.$store.dispatch('GET_ALL_SALUTATIONS');
      await this.$store.dispatch('GET_ALL_DATAHELPER');
      if (!this.user || !this.user.id) {
        await this.GET_USERDATA().then((result) => {
          this.SET_USER({user: result.data})
        })
      }
      this.loading = false;
    },
    findSubmission(submissionId) {
      return this.submissions.find(submission => submission.id == submissionId);
    },
  },
}
</script>

